export default function Network() {
  const benefits = [
    {
      icon: 'ri-global-line',
      title: 'Worldwide Distribution',
      description: 'Reach audiences across the globe with our extensive network of 130+ news outlets and distribution channels.',
      mobileDescription: 'Global reach with 130+ outlets.'
    },
    {
      icon: 'ri-team-line',
      title: 'Benefits of a Larger Team on Your Own',
      description: 'Access professional resources, editorial support, and infrastructure while maintaining your independence and creative control.',
      mobileDescription: 'Professional resources with independence.'
    },
    {
      icon: 'ri-building-line',
      title: 'Your Business, We Help You Structure',
      description: 'Get expert guidance on building your journalism business with proven frameworks, best practices, and operational support.',
      mobileDescription: 'Expert business guidance and support.'
    },
    {
      icon: 'ri-plug-line',
      title: 'Plugin to Over 50+ CRMs',
      description: 'Seamlessly integrate with our ecosystem\'s CRM solutions to manage your audience, content, and business operations efficiently.',
      mobileDescription: 'Integrate with 50+ CRM solutions.'
    }
  ];

  return (
    <section id="network" className="py-24 bg-gradient-to-b from-gray-50 to-green-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-green-100 text-green-700 text-sm font-semibold rounded-full mb-6 whitespace-nowrap">
            Our Network
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
            <span className="text-green-600">Independent Journalist</span> Network
          </h2>
          <p className="hidden md:block text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Join a thriving community of independent journalists who benefit from professional infrastructure, global reach, and comprehensive business support while maintaining complete editorial independence.
          </p>
          <p className="md:hidden text-base text-gray-600 max-w-xl mx-auto leading-relaxed">
            Professional infrastructure with editorial independence.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid md:grid-cols-2 gap-8 mb-16">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 group cursor-pointer border border-gray-100"
            >
              <div className="flex items-start gap-6">
                <div className="flex-shrink-0">
                  <div className="w-16 h-16 bg-green-100 rounded-xl flex items-center justify-center group-hover:bg-green-600 transition-colors duration-300">
                    <i className={`${benefit.icon} text-3xl text-green-600 group-hover:text-white transition-colors duration-300`}></i>
                  </div>
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{benefit.title}</h3>
                  <p className="hidden md:block text-base text-gray-600 leading-relaxed">{benefit.description}</p>
                  <p className="md:hidden text-sm text-gray-600 leading-relaxed">{benefit.mobileDescription}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="bg-gradient-to-br from-green-600 to-green-700 rounded-3xl p-12 text-center shadow-2xl">
          <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">Ready to Join Our Network?</h3>
          <p className="hidden md:block text-lg text-green-50 mb-8 max-w-2xl mx-auto leading-relaxed">
            Become part of a decentralized media revolution. Get access to professional tools, global distribution, and a supportive community of independent journalists.
          </p>
          <p className="md:hidden text-base text-green-50 mb-8 max-w-xl mx-auto leading-relaxed">
            Join the decentralized media revolution.
          </p>
          <a href="#contact" className="inline-block px-8 py-4 bg-white text-green-600 text-base font-semibold rounded-full hover:bg-gray-50 transition-all hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer">
            Get Started Today
          </a>
        </div>
      </div>
    </section>
  );
}
